import React from 'react';
import Table from 'components/Table/Table';
import { Close } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { TextField } from '@material-ui/core';
import { wsUpdate } from 'services/WService';

export default function ListGroupBonification(props) {
  const { statePromo, deleteBoniProduct, boniGroup, promotion, setBoniGroups, showNotify } = props;

  async function setProductValue(value, name, product) {
    setBoniGroups((groups) => {
      let newGroups = [...groups];
      let groupIndex = newGroups.findIndex((group) => group === boniGroup);
      let productIndex = newGroups[groupIndex].products.findIndex(
        (groupProduct) => groupProduct === product,
      );
      newGroups[groupIndex].products[productIndex][name] = value;
      return newGroups;
    });
  }

  async function updateProduct(product) {
    let res = await wsUpdate(`prom/bonification-product/${product.id}`, {
      discount: product.discount,
      price: product.price,
    });

    if (res.success) {
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  return (
    <Table
      striped
      tableHead={['#', 'ItemCode', 'ItemName', 'Precio', 'Descuento', 'Eliminar']}
      tableData={boniGroup.products.map((product, i) => {
        return [
          i + 1,
          product.ItemCode,
          product.ItemName,
          <TextField
            value={product.price || 0}
            type="number"
            disabled={promotion.surprise_plan !== true || statePromo}
            onChange={(e) => {
              setProductValue(e.target.value, 'price', product);
            }}
            onBlur={() => {
              updateProduct(product);
            }}
            inputProps={{
              min: 0,
            }}
          />,
          <TextField
            value={parseFloat(product.discount)}
            type="number"
            disabled={promotion.surprise_plan !== true || statePromo}
            onChange={(e) => {
              setProductValue(e.target.value, 'discount', product);
            }}
            onBlur={() => {
              updateProduct(product);
            }}
            inputProps={{
              min: 0,
              max: 100,
            }}
          />,
          <Button
            round
            size="sm"
            justIcon
            color="danger"
            onClick={() => {
              deleteBoniProduct(product);
            }}
            disabled={statePromo}
          >
            <Close />
          </Button>,
        ];
      })}
    />
  );
}
